const isIOS = u => !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

export default isIOS
